export type DocumentNavigationOptions = {
    replace?: boolean;
};

export const navigateToDocument = (href: string, options: DocumentNavigationOptions = {}) => {
    if (typeof window === "undefined") {
        return;
    }

    if (!href) {
        return;
    }

    const target = new URL(href, window.location.origin).toString();
    if (target === window.location.href) {
        return;
    }

    if (options.replace) {
        window.location.replace(target);
        return;
    }

    window.location.assign(target);
};
